import { Backdrop, Box, Slide, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { updateProjectCreationState } from '../../../../redux/projectCreationSlice';
import { afterValidate, calculateSpeakingTime, detectLanguageInBCP47, getNamesFromIds, objectToArray, selectedLanguage } from '../../../../utils/commonServices';
import CustomInput from '../CustomInput';
import { getErrorMsg } from '../../../../utils/validator';
import LeftIcon from '../../icons/LeftIcon';
import RightIcon from '../../icons/RightIcon';
import CustomAutocomplete from '../CustomAutoComplete';
import { azureLanguageNames } from '../../../../constants/constants';


const VoScriptInput = (props) => {

  const { pageData, setPageData, slideDirection, nextPageHandler, prevPageHandler, pageIndex, closeHandler, totalScreens, title, note } = props
  const createProjectReducer = useSelector((state) => state.createProjectReducer);
  const commonReducer = useSelector((state) => state.commonReducer);
  const contentReducer = useSelector((state) => state.contentReducer);
  const dropdownReducer = useSelector((state)=> state.persistedReducers.dropdownReducer)
  const isListView = commonReducer?.list_view
  const dispatch = useDispatch()
  const [descriptionValidationflag, setDescriptionvalidationFlag] = useState(false)
  const charLimit = 25000;
  const [charLeft, setCharLeft] = useState(25000)
  const projectType = getNamesFromIds(createProjectReducer.commonPageData.projectTypeId, dropdownReducer?.project_type)?.name
  const finishedHandler = () => {
    validateInputs(true)
    afterValidate(nextPageHandler);
  }
  const [baseLanguage, setBaseLanguage] = useState('en-US')
  const validateInputs = (flag) => {
    setDescriptionvalidationFlag(flag)
  }
  const onChangeHandler = (event) => {
    const language = detectLanguageInBCP47(event.target.value);
    setBaseLanguage(language)
    const length = calculateSpeakingTime(event.target.value)
    setCharLeft(charLimit - event.target.value?.length)
    dispatch(updateProjectCreationState({ commonPageData: { ...createProjectReducer.commonPageData, lengthId: length?.speakingTime, userScript: createProjectReducer.commonPageData.userScript != "" ? event.target.value : event.target.value.trim(), language: language } }))
  }

 

  useEffect(() => {
    const keyDownHandler = (event) => {
      if (event.key === "Enter") {
        event.preventDefault();
        finishedHandler();
      }
    };
    document.addEventListener("keydown", keyDownHandler)
    return () => {
      document.removeEventListener("keydown", keyDownHandler);
    };
  }, [createProjectReducer.commonPageData.userScript]);

  return (
    <>
      {/* <Slide direction={slideDirection} in={true} mountOnEnter unmountOnExit>
    <Backdrop
    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 , backdropFilter: 'blur(18px) !important', display:'flex', flexDirection:'column', background: '#08231B88 0% 0% no-repeat padding-box', }}
    open={createProjectReducer.open_backdrop_project_creation}
    > */}
      <Box sx={{ width: isListView ? '100%' : '90%', height: '100%', display: 'flex', flexDirection: 'column' }}>
        {(!isListView || contentReducer?.create_content_open) && <Typography textAlign={'right'} sx={{ fontSize: '16px', cursor: 'pointer', mt: 5, mr: 3 }} onClick={closeHandler}>Close X</Typography>}
        <Box flexGrow={1} className='flex col ' sx={{ paddingLeft: isListView ? '5vw' : '14vw', marginTop: isListView ? { xs: '6%', sm: '4%', md: '3%', xl: '4%' } : { xs: '8%', sm: '6%', md: '4%', xl: '6%' } }}>
          <Box mb={4}>
            <Typography sx={{ fontSize: isListView ? { xs: '15px', sm: '18px', md: '22px', lg: '24px', xl: '35px' } : {xs:'15px',sm:'18px',md:'22px',lg:'24px',xl:'35px'}, color: 'white', fontFamily: 'Rubik' }}>{`${pageIndex}/${totalScreens}`}</Typography>
            <Typography sx={{ fontSize: isListView ? { xs: '18px', sm: '20px', md: '28px', lg: '32px', xl: '45px' } : {xs:'30px',sm:'35px',md:'40px',lg:'45px',xl:'65px'}, color: 'white', fontFamily: 'Rubik' }}>{title}</Typography>
            <Typography sx={{ fontSize: isListView ? { xs: '10px', sm: '12px', md: '15px', lg: '18px', xl: '24px' } : {xs:'15px',sm:'18px',md:'22px',lg:'24px',xl:'35px'}, color: 'white', fontFamily: 'Rubik' }}>{note}</Typography>
          </Box>
          <Box className='flex col j-center' sx={{ width: '80%' }}>
            <CustomInput
              id='user-script'
              onFocus={() => setDescriptionvalidationFlag(false)}
              onBlur={() => setDescriptionvalidationFlag(true)}
              // type='sendInput'
              required
              errorFlag={descriptionValidationflag && getErrorMsg("description", createProjectReducer.commonPageData.userScript) != ""}
              errorMsg={getErrorMsg("description", createProjectReducer.commonPageData.userScript)}
              fullWidth
              medium
              multiline
              maxRows={8}
              minRows={5}
              max={25000}
              bottom={-20}
              msgColor='red'
              placeholder="Type/paste your text here..."
              onChange={onChangeHandler}
              value={createProjectReducer.commonPageData.userScript}
              onButtonClick={pageIndex !== totalScreens ? finishedHandler : null}
            />
            {charLeft < 25000 && <Typography
              variant="body1"
              sx={{
                fontFamily: 'Rubik',
                color: "#BBBBBB",
                fontSize: { xs: '12px', lg: '13px', xl: '18px' },
                // position:'absolute',

                //top: '8px',
                fontWeight: 600
                //paddingTop: 20,
              }}
            >

              <Box textAlign='left'>{`Characters left: ${charLeft}`}</Box>
            </Typography>}
          </Box>
          <Box mb={4}>
          <Typography sx={{ fontSize: isListView ? { xs: '18px', sm: '20px', md: '28px', lg: '32px', xl: '45px' } : {xs:'30px',sm:'35px',md:'40px',lg:'45px',xl:'65px'}, color: 'white', fontFamily: 'Rubik' }}>{`What will be the accent for your ${projectType}?`}</Typography>
            <Typography sx={{ fontSize: isListView ? { xs: '10px', sm: '12px', md: '15px', lg: '18px', xl: '24px' } : {xs:'15px',sm:'18px',md:'22px',lg:'24px',xl:'35px'}, color: 'white', fontFamily: 'Rubik' }}>Select the Accent.</Typography>
          </Box>
          <Box className='flex col j-center' sx={{ width: '80%' }}>
          <CustomAutocomplete
                          id="script_language"
                          options={  objectToArray(azureLanguageNames)?.filter(item => item.id.startsWith(baseLanguage?.substring(0, 2)))}
                          // onFocus={() => {
                          //   setScriptLengthValidationFlag(false)
                          // }}
                          // onBlur={() => setScriptLengthValidationFlag(true)}
                          // required
                          // errorFlag={scriptLengthValidationFlag && getErrorMsg("script_length", createProjectReducer.commonPageData.language, createProjectReducer.commonPageData?.projectTypeId) != ""}
                          // errorMsg={getErrorMsg("script_length", createProjectReducer.commonPageData.language, createProjectReducer.commonPageData?.projectTypeId)}
                          value={selectedLanguage(createProjectReducer.commonPageData.language)}
                          onChange={(event, newValue) => {
                            dispatch(updateProjectCreationState({commonPageData: {...createProjectReducer.commonPageData, language: newValue.id }}))
                              }}
                          label=""
                          placeholder={`Select the Accent for your ${projectType}`}
                          getOptionLabel={(option) =>
                              Object.keys(option).length > 0 ? `${option.name}` : ""
                          }
                          // renderInput={(params) => (
                          //   <TextField
                          //     {...params}
                          //     placeholder={`Select the language of your ${projectType}`}
                          //     required
                          //     error={
                          //       scriptLengthValidationFlag &&
                          //       getErrorMsg(
                          //         "script_length",
                          //         createProjectReducer.commonPageData.lengthId,
                          //         createProjectReducer.commonPageData?.projectTypeId
                          //       ) !== ""
                          //     }
                          //     helperText={
                          //       scriptLengthValidationFlag
                          //         ? getErrorMsg(
                          //             "script_length",
                          //             createProjectReducer.commonPageData.lengthId,
                          //             createProjectReducer.commonPageData?.projectTypeId
                          //           )
                          //         : ""
                          //     }
                          //     variant="outlined"
                          //     size="medium"
                          //   />
                          // )}
                          renderOption={(props, option, { index }) => (
                            <React.Fragment key={option.id}>
                              {index === 7 && (
                                <li style={{ borderTop: "1px dotted #000", margin: "4px 0" }} />
                              )}
                              <li {...props}>{option.name}</li>
                            </React.Fragment>
                          )}
                          medium
                          msgColor='red'
                      /> 
          </Box>
        </Box>
        <Box className='flex' sx={{ justifyContent: 'flex-end', mb: 3, mr: 3 }}>
          <LeftIcon sx={{ opacity: pageIndex === 1 && 0.5, fontSize: { xs: '45px', sm: '55px', lg: '65px', xl: '82px' }, cursor: 'pointer' }} onClick={pageIndex !== 1 ? prevPageHandler : null} />
          <RightIcon sx={{ cursor: 'pointer', fontSize: { xs: '45px', sm: '55px', lg: '65px', xl: '82px' } }} onClick={pageIndex !== totalScreens ? finishedHandler : null} />
        </Box>
      </Box>
      {/* </Backdrop>
    </Slide> */}
    </>
  )
}

export default VoScriptInput